import { jsx as _jsx } from "react/jsx-runtime";
import { AttributeCell } from "../Attribute/AttributeCell";
import { AttributeComponentContext, ConfigurationComponentContext, OtherComponentContext, } from "../ComponentContext";
import { ContainerCell } from "../Container/ContainerCell";
import { ControlCell } from "../Controls/ControlCell";
import { ValueCell } from "../Value/ValueCell";
import { LayoutCellContext } from "./LayoutCellContext";
import { LayoutCellDebug } from "./LayoutCellDebug";
import { PluginHelper } from "./helpers/PluginHelper";
/**
 * Layout cell in react-page layout
 * @param props
 * @returns
 */
export function LayoutCell(props) {
    const { node } = props;
    const content = PluginHelper.isAttributePlugin(node) ? (_jsx(AttributeCell, { node: node })) : PluginHelper.isValuePlugin(node) ? (_jsx(ValueCell, { node: node })) : PluginHelper.isControlPlugin(node) ? (_jsx(ControlCell, { node: node })) : PluginHelper.isAttributeComponentPlugin(node) ? (_jsx(ContainerCell, { node: node, componentContext: AttributeComponentContext })) : PluginHelper.isConfigurationComponentPlugin(node) ? (_jsx(ContainerCell, { node: node, componentContext: ConfigurationComponentContext })) : (_jsx(ContainerCell, { node: node, componentContext: OtherComponentContext }));
    return (_jsx(LayoutCellContext.Provider, { value: node, children: _jsx(LayoutCellDebug, { cell: node, children: content }) }));
}
//# sourceMappingURL=LayoutCell.js.map